import { render } from "./Aside.vue?vue&type=template&id=de46fd2e&scoped=true&ts=true"
import script from "./Aside.vue?vue&type=script&lang=ts"
export * from "./Aside.vue?vue&type=script&lang=ts"

import "./Aside.vue?vue&type=style&index=0&id=de46fd2e&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Muhammad Sohail\\Herd\\yellowrockshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de46fd2e"]])

export default __exports__